<div class="row mt-2">
  <div class="pl-3">
    <p (click)="content.toggle(); collapseEvent.emit(content.isCollapsed)" class="mouse-pointer mb-0">
      <mdb-icon *ngIf="!subCollapse" fas icon="info-circle'" class="" aria-hidden="true"></mdb-icon>
      <mdb-icon class="pr-1" icon="plus" fas *ngIf="subCollapse && content.isCollapsed"></mdb-icon>
      <mdb-icon class="pr-1" icon="minus" fas *ngIf="subCollapse && !content.isCollapsed"></mdb-icon>
      <a onclick="return false;">
        <span onclick="return false;" class="default" [class.text-gray]="subCollapse">{{ label }}</span>
      </a>
      <mdb-icon class="pl-1" icon="angle-down" fas *ngIf="withArrow && content.isCollapsed"></mdb-icon>
      <mdb-icon class="pl-1" icon="angle-up" fas *ngIf="withArrow && !content.isCollapsed"></mdb-icon>
    </p>
  </div>
</div>

<div class="" mdbCollapse [isCollapsed]="isCollapsed" #content="bs-collapse">
  <ng-content></ng-content>
</div>
